import './polyfill.js'
import { ProductDetails } from './classes/ProductDetails.js'
import { MandBProductDetails } from './classes/MandBProductDetails.js'
import { AuthorDetails } from './classes/AuthorDetails'
import { AlgoliaDataList } from './classes/AlgoliaDataList'
import { getQueryParameterValue, getSubscriptionDetails, subscriptionTileContent, elementReady, formatVitalsourceLinks } from './utilities'
import { SupafolioLookupCarousel } from './classes/SupafolioLookupCarousel.js'
import SupapressV3Search from './supapress-v3/supapress-v3-search.js'
import { addClientSpecificFunctions } from './clients/clients.js'
window.theme = window.theme || {}
const opts = {
  staticData: true
}

document.addEventListener('DOMContentLoaded', async () => {
  const client = supafolio('', '', window.theme.settings.supaduCatalog, opts)
  const search = document.querySelector('.js-supapress-v3-search-template')
  const productDetailsWrapper = document.getElementById('products-details-wrapper')
  const contributorDetailsWrapper = document.getElementById('contributor-details')

  if (contributorDetailsWrapper !== null) {
    let authordetails = ''
    // contributor details page
    if (getQueryParameterValue('contributorID')) {
      authordetails = new AuthorDetails(client, getQueryParameterValue('contributorID'))
    } else {
      // featured author section
      const featuredAuthorID = contributorDetailsWrapper.getAttribute('contributorid')
      authordetails = new AuthorDetails(client, featuredAuthorID)
    }
    await authordetails.run()
  }
  if (productDetailsWrapper) {
    const isbn13 = productDetailsWrapper.getAttribute('barcode')
    let productDetails
    if (productDetailsWrapper.classList.contains('js-mandb-product-details-wrapper')) {
      productDetails = new MandBProductDetails(client, isbn13)
    } else {
      productDetails = new ProductDetails(client, isbn13)
    }
    await productDetails.run()
  }

  if (document.querySelectorAll('.js-supafolio-book-carousel-section').length) {
    document.querySelectorAll('.js-supafolio-book-carousel-section').forEach((section) => {
      if (!section.dataset.shopifyBarcode || typeof section.dataset.shopifyBarcode !== 'string') {
        return
      }
      if (!section.dataset.productHits) {
        return
      }
      SupafolioLookupCarousel.initCarousel(client, section, section.dataset.shopifyBarcode.trim().split(','), section.dataset.productHits)
    })
  }

  if (search !== null && window.theme.settings.showV3search === 'true') {
    const supapressV3Search = new SupapressV3Search(search)
    supapressV3Search.initialiseSearch()
    // apply parameter to search fields if press/next browser button clicked
    window.addEventListener('popstate', function () {
      const searchParam = getQueryParameterValue('q')
      if (searchParam !== '') {
        document.querySelectorAll('.search-field').forEach(field => {
          field.value = searchParam
        })
      }
    })
  }

  if (window.theme.settings.template === 'page.list-subscriptions') {
    const subscriptionsItems = document.querySelectorAll('.subscription__item')
    subscriptionsItems.forEach((item) => {
      const collectionName = item.dataset.collection
      getSubscriptionDetails(collectionName).then((data) => {
        subscriptionTileContent(item, data, collectionName)
      })
    })
  }

  /* AA changes applied for Announcement Carousel */
  if (document.querySelector('.announcement-slider')) {
    elementReady('.announcement-slider.slick-slider').then((announcementSlider) => {
      announcementSlider.querySelector('.slick-track').setAttribute('title', 'Announcement Slider')
      announcementSlider.querySelectorAll('.announcement-slider__slide').forEach((element) => {
        if (element.getAttribute('aria-describedby') !== null) {
          element.querySelector('span:first-child').setAttribute('id', element.getAttribute('aria-describedby'))
        }
      })
    })
  }
  /* AA changes applied for Hero Slideshow */
  if (document.querySelector('.hero-slideshow')) {
    elementReady('.hero-slideshow .hero.slick-slider').then((homeSlideShow) => {
      homeSlideShow.querySelector('.slick-track').setAttribute('title', 'Hero Slider')
      homeSlideShow.querySelectorAll('.slideshow__slide').forEach((element) => {
        if (element.getAttribute('aria-describedby') !== null) {
          element.querySelector('.hero__image-wrapper').setAttribute('id', element.getAttribute('aria-describedby'))
        }
      })
    })
  }

  // assign click events to all VS links if on page
  if (document.querySelectorAll('.vitalsource-ebook-link').length) {
    const vitalsourceLinks = document.querySelectorAll('.vitalsource-ebook-link')
    vitalsourceLinks.forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault()
        const updatedUrl = formatVitalsourceLinks(event)
        link.href = updatedUrl
        window.open(updatedUrl, '_blank')
      })
    })
  }

  // assign the search to blog type if article type parameter is in the url
  if (getQueryParameterValue('type') === 'article') {
    const hiddenSearchTypeField = document.querySelector('.js-search-bar-page input[name="type"]')
    hiddenSearchTypeField.value = 'article'
  }

  // on contributor search clear the search bar value
  const queryParameter = getQueryParameterValue('q')
  const searchBarInput = document.querySelector('.js-search-bar-page .input-group-field')
  if (queryParameter && queryParameter.includes('contributor:') && searchBarInput) {
    searchBarInput.value = ''
  }

  const algoliaDataList = new AlgoliaDataList()
  algoliaDataList.showAlgoliaLists()

  // Running specific js based on current catalog name
  addClientSpecificFunctions(window.theme.settings.supaduCatalog)
})
